import {
  useSessionResult as useSharedSessionResult,
  type SessionResultState,
} from "@heraion/ui";
import type { SessionResult as SessionResultT } from "@heraion/shared";

import { apiFetch } from "./api";
import { lsCache } from "./lsCache";

// Thin mount over the shared SessionSummary/useSessionResult (CN-7) for the
// web console Workouts detail pane. The shared hook owns fetch + validation
// + the SWR sequencing; this mount injects apiFetch and the tiny per-id
// localStorage paint so re-selecting a session repaints instantly before
// the network confirms ([[reference_web_rnw_needs_swr_cache]]). Read-only.
export function useSessionResult(
  sessionId: string | null,
  /** The session's updatedAt: a correction keeps the id (#38). */
  version?: string,
): SessionResultState {
  return useSharedSessionResult({
    apiFetch,
    sessionId,
    ...(version !== undefined ? { version } : {}),
    readCached: (id) => lsCache<SessionResultT>(`workouts/result/${id}`).read(),
    writeCached: (id, result) => {
      void lsCache<SessionResultT>(`workouts/result/${id}`).write(result);
    },
  });
}
